"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJsonFooter = void 0;
const getJsonFooter = (context, build = true) => {
    const MethodType = require('@gerenciatd/next.utils.types').MethodType;
    const Request = require('@gerenciatd/next.utils.request').default;
    const FrontSonda = require('@gerenciatd/next.utils.front-sonda').default;
    const calculateHeaderParams = require('@gerenciatd/next.utils.build-environments').calculateHeaderParams;
    const familyApi = 'bucket';
    let PATH_GET_FOOTER_INFO = '/static/json/footerPro/footerPro.json';
    if (`${process.env.NEXT_PUBLIC_ENV_SEGMENT}` === 'empresas') {
        PATH_GET_FOOTER_INFO = '/static/json/footerPro/footerProEmp.json';
    }
    console.log({ PATH_GET_FOOTER_INFO });
    const errorDetected = (sonda) => {
        sonda.errorMessage({
            info: `Ha fallado la petición al json: ${sonda.processName}`,
        });
    };
    const myFrontSonda = new FrontSonda({
        processName: 'MISCELLANEOUS.GET_FOOTER_INFO',
        context,
        filePath: 'sagas/header',
    });
    const { bucket: connectionData } = context.environment;
    const { endpoint: host } = connectionData;
    const URL_API = `${host}${PATH_GET_FOOTER_INFO}`;
    try {
        const headers2Use = calculateHeaderParams(build, familyApi, context);
        const request = new Request({
            method: MethodType.GET,
            endpoint: URL_API,
            onError: () => errorDetected(myFrontSonda),
            onTimeout: () => errorDetected(myFrontSonda),
            headers: Object.assign({}, headers2Use),
        });
        return request.makeRequest();
    }
    catch (err) {
        myFrontSonda.errorMessage({
            error: err,
            info: 'Ha fallado js durante la invocación al json',
        });
        return null;
    }
};
exports.getJsonFooter = getJsonFooter;
exports.default = exports.getJsonFooter;
//# sourceMappingURL=getJsonFooterPromise.js.map